export const MARKETINGS_TYPES = {
  EVENT: 'event',
  EVENT_CANCEL: 'eventCancel',
  CLIENT: 'client',
  EVENT_FINALIZE_BY_AD: 'eventFinalizeAdv',
  EVENT_MOVE: 'eventMove',
}
